import React, { useEffect, useState, useCallback } from 'react';
import { SinglePackage } from 'utils/api/models/numbers/singlePackage';
import { ECommerceService } from 'services/eCommerce/eCommerce';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import SubExpansionPanel from './subcomponents/SubExpansionPanel';
import { ISelectedPackage } from 'views/PrepaidLoyalty/AddNewServices';

interface ISubExpansionPanelWrapperProps {
	servicesPackage: {
		type: types.ecommerce.PackageType;
		groupBy?: types.topUpAddOns.IGroupBy;
	};
	collapsedSub: string;
	handleSelected: (singlePackage: ISelectedPackage) => void;
	handleCollapsedSub: (name: string) => void;
	selectedPackages: ISelectedPackage[];
	setPackagesLoading: React.Dispatch<
		React.SetStateAction<
			{
				type: types.ecommerce.PackageType;
				loading: boolean;
			}[]
		>
	>;
	setSumOfChildPackages: React.Dispatch<React.SetStateAction<number>>;
}

const SubExpansionPanelWrapper = ({
	servicesPackage,
	collapsedSub,
	handleCollapsedSub,
	handleSelected,
	selectedPackages,
	setPackagesLoading,
	setSumOfChildPackages,
}: ISubExpansionPanelWrapperProps) => {
	const [packages, setPackages] = useState<SinglePackage[]>([]);

	const setPackagesLoadingForThisService = useCallback(
		(state: boolean) => {
			setPackagesLoading((oldState) => {
				return oldState.map((packageLoading) => {
					if (packageLoading.type === servicesPackage.type) {
						return { type: packageLoading.type, loading: state };
					} else {
						return packageLoading;
					}
				});
			});
		},
		[servicesPackage, setPackagesLoading]
	);

	useEffect(() => {
		if (setPackagesLoadingForThisService) {
			setPackagesLoadingForThisService(true);
			ECommerceService.getPackages(servicesPackage.type, 'PREPAID_LOYALTY').subscribe(({ packages }) => {
				setSumOfChildPackages((oldPackages) => oldPackages + packages.length);
				setPackagesLoadingForThisService(false);
				setPackages(packages);
			});
		}
	}, [servicesPackage, setPackagesLoadingForThisService, setSumOfChildPackages]);

	return (
		<ConditionalRender
			show={packages.length > 0}
			onTrue={() => {
				return (
					<ConditionalRender
						show={!!servicesPackage.groupBy}
						onTrue={() => (
							<>
								{servicesPackage.groupBy?.values.map((value) => (
									<SubExpansionPanel
										key={value}
										collapsedSub={collapsedSub}
										handleSelected={handleSelected}
										handleCollapsedSub={handleCollapsedSub}
										packages={packages.filter(
											(singlePackage: SinglePackage) =>
												singlePackage[servicesPackage.groupBy!.key] === value
										)}
										packageIdentifier={value}
										selectedPackages={selectedPackages}
									/>
								))}
							</>
						)}
						onFalse={() => (
							<SubExpansionPanel
								collapsedSub={collapsedSub}
								handleSelected={handleSelected}
								handleCollapsedSub={handleCollapsedSub}
								packages={packages}
								packageIdentifier={servicesPackage.type}
								selectedPackages={selectedPackages}
							/>
						)}
					/>
				);
			}}
		/>
	);
};

export default SubExpansionPanelWrapper;
